import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../../../utils/URLTools';

const apiFetchPredesTransactionsEdit = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'editPredesTransactions',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext.appContext,
    },
  });
  return axios.put(serviceUrl, {
    comments: payload.params.comments,
    departureDateTime: moment(payload.params.departureDateTime).format('YYYY-MM-DD HH:mm:ss'),
    impcFrom: payload.params.impcFrom,
    impcTo: payload.params.impcTo,
    operatorFrom: payload.params.operatorFrom,
    operatorTo: payload.params.operatorTo,
    plannedArrivalDateTime: moment(payload.params.plannedArrivalDateTime).format('YYYY-MM-DD HH:mm:ss'),
    quantity: payload.params.quantity,
    transactionId: payload.params.transactionId,
  });
};

export default apiFetchPredesTransactionsEdit;
